import React from "react";
export default function Footer() {
  return (
    <div className="Footer">
      <small>
        <a
          href="https://practical-agnesi-fa6c5b.netlify.app/"
          target="_blank"
          rel="noreferrer"
        >
          Madeline Hardy
        </a>{" "}
        has coded this page learnt through{" "}
        <a href="https://www.shecodes.io/" target="_blank" rel="noreferrer">
          SheCodes
        </a>
        .{" "}
        <a
          href="https://github.com/Mad-016/weather-app-react"
          target="_blank"
          rel="noreferrer"
        >
          Open-source code{" "}
        </a>
        available.
      </small>
    </div>
  );
}
